<template>
    <div class="container">
        <div>
            <el-breadcrumb separator="/">
                <el-breadcrumb-item
                    :to="{ path: $myRouter.getPreviousRoute().path, params: $myRouter.getPreviousRoute().params }">返回列表</el-breadcrumb-item>
                <el-breadcrumb-item>复检页面</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <hr>
        <!-- <el-button @click="handleSubmitApprove" type="primary" size="small" plain text
            class="approve-button">提交审批</el-button> -->
        <el-tabs v-model="activeTab">
            <el-tab-pane label="复检红外1" name="hw1">
                <hw-one :project-id="project_id" :site-id="site_id"></hw-one>
            </el-tab-pane>
            <el-tab-pane label="复检红外2" name="hw2">
                <hw-two :project-id="project_id" :site-id="site_id"></hw-two>
            </el-tab-pane>
            <el-tab-pane label="整改建议" name="zg_zgjy">
                <el-button type="primary" plain @click="generateSummary" size="mini"
                    style="margin-bottom: 10px;">生成直观和CMA整改建议</el-button>
                <div style="display: flex; justify-content: space-between;">
                    <el-form :model="zg_form" style="width: 50%;margin-right: 10px;">
                        <table width="100%">
                            <tr>
                                <td>
                                    <el-input type="textarea" :rows="30" placeholder="直观整改建议"
                                        v-model="zg_form.content"></el-input>
                                </td>
                            </tr>
                        </table>
                    </el-form>
                    <el-form :model="cma_form" style="width: 50%; margin-left: 10px;">
                        <table width="100%">
                            <tr>
                                <td>
                                    <el-input type="textarea" :rows="30" placeholder="CMA整改建议"
                                        v-model="cma_form.content"></el-input>
                                </td>
                            </tr>
                        </table>
                    </el-form>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>

export default {
    data() {
        return {
            project_id: "",
            site_id: "",
            activeTab: 'hw1',
            zg_form: {
                content: ''
            },
            cma_form: {
                content: ''
            }
        };
    },
    methods: {
        //提交审批中
        async handleSubmitApprove() {
            try {
                await this.$Api.post('submit_approve', {
                    project_id: this.project_id,
                    site_ids: this.site_id,
                    site_type: this.site_type
                })
                this.$message.success("提交成功")
            } catch (e) {
                this.$message.error(e.errormsg)
            }
        },
        async generateSummary() {
            try {
                await this.$Api.post("generate_zgjy", {
                    project_id: this.project_id,
                    site_id: this.site_id
                });
                this.getData();
                this.$notify({ title: '生成成功', message: '生成成功', type: 'success' })
            } catch (e) {
                this.$notify({ title: '生成失败', message: e.errormsg })
            }
        },
        async getData() {
            try {
                let params = {
                    project_id: this.$route.params.project_id,
                    site_id: this.$route.params.site_id
                }
                let res = await this.$Api.get("fj_zgjy", { params: params });
                if (res) {
                    this.zg_form.content = res.zg;
                    this.cma_form.content = res.cma;
                }
            } catch (e) {
                this.$notify({ title: '获取数据出错', message: e.message })

            }
        }
    },

    created() {
        this.project_id = this.$route.params.project_id;
        this.site_id = this.$route.params.site_id;
        this.getData();
    }
};
</script>

<style scoped>
.flex-container {
    display: flex;
    justify-content: space-start;
}

.section1 {
    width: 20%;
    margin-right: 8px;
}

.section2 {
    width: 80%;
}

.table {
    width: 100%;
}

.inline-block {
    display: inline-block;
    margin-left: 5px;
    margin-right: 5px;
}

table,
table tr td {
    border: 1px solid black;
    border-collapse: collapse;
    text-align: center;
    vertical-align: middle !important;
}

.approve-button {
    position: absolute;
    margin-right: 10px;
    right: 0;
    top: 1;

}
</style>